import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

interface SheetData {
  name: string;
  rows: any[][];
}

@Component({
  selector: 'app-xlsx-viewer',
  templateUrl: './xlsx-viewer.component.html',
  styleUrls: ['./xlsx-viewer.component.scss']
})
export class XlsxViewerComponent implements OnChanges {
  static readonly MAX_ROWS = 5000;

  @Input() blob: Blob | null = null;

  sheets: SheetData[] = [];
  activeSheetIndex = 0;
  loading = false;
  error: string | null = null;
  truncatedWarning = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['blob']) this.render();
  }

  trackByIdx(idx: number): number {
    return idx;
  }

  private async render(): Promise<void> {
    if (!this.blob) {
      this.sheets = [];
      return;
    }
    this.loading = true;
    this.error = null;
    this.truncatedWarning = false;
    try {
      const buf = await this.blob.arrayBuffer();
      const XLSX = await import('xlsx');
      const wb = XLSX.read(buf, { type: 'array' });
      this.sheets = wb.SheetNames.map(name => {
        const ws = wb.Sheets[name];
        let rows = XLSX.utils.sheet_to_json<any[]>(ws, { header: 1, defval: '' });
        if (rows.length > XlsxViewerComponent.MAX_ROWS) {
          this.truncatedWarning = true;
          rows = rows.slice(0, XlsxViewerComponent.MAX_ROWS);
        }
        return { name, rows };
      });
      this.activeSheetIndex = 0;
    } catch (e: any) {
      this.error = e?.message ?? 'No se pudo leer el archivo Excel.';
      this.sheets = [];
    } finally {
      this.loading = false;
    }
  }
}
